/**
 * Правила валидации для форм
 */

/**
 * Минимальная длина имени
 */
export const MIN_NAME_LENGTH = 1;

/**
 * Максимальная длина имени
 */
export const MAX_NAME_LENGTH = 100;

/**
 * Максимальная длина места проведения
 */
export const MAX_LOCATION_LENGTH = 500;

/**
 * Минимальное количество гостей
 */
export const MIN_GUEST_COUNT = 1;

/**
 * Максимальное количество гостей
 */
export const MAX_GUEST_COUNT = 1000;

/**
 * Максимальная длина сообщения
 */
export const MAX_MESSAGE_LENGTH = 1000;

/**
 * Максимальная длина имени гостя
 */
export const MAX_GUEST_NAME_LENGTH = 100;

/**
 * Формат даты для API (YYYY-MM-DD)
 */
export const API_DATE_FORMAT = 'YYYY-MM-DD';

/**
 * Формат даты для пользователя (DD-MM-YYYY)
 */
export const USER_DATE_FORMAT = 'DD-MM-YYYY';
